import { render, staticRenderFns } from "./Bailiff.vue?vue&type=template&id=dc08f658&"
import script from "./Bailiff.vue?vue&type=script&lang=js&"
export * from "./Bailiff.vue?vue&type=script&lang=js&"
import style0 from "./Bailiff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports